import { call, put, takeLatest, all } from "redux-saga/effects";
import {
  getAuthorsStart,
  getAuthorsSuccess,
  getAuthorsFailure,
} from "../authors";
import { fetchAuthors } from "../services/authors";

function* getAuthorsWorker(): Generator<any, void, any> {
  try {
    const response = yield call(fetchAuthors);
    yield put(getAuthorsSuccess(response.authors || []));
  } catch (error: any) {
    yield put(getAuthorsFailure(error.message || "Failed to fetch authors"));
  }
}

function* authorsSagaWatcher() {
  yield takeLatest(getAuthorsStart.type, getAuthorsWorker);
}

// This saga will run once on saga startup
function* authorsInitSaga() {
  yield put(getAuthorsStart());
}

export default function* authorsRootSaga() {
  yield all([
    authorsInitSaga(), // fetch authors on saga startup
    authorsSagaWatcher(), // watch for manual fetches
  ]);
}
